import React from 'react';

import PermissionGuard from 'src/components/guards/PermissionGuard';
import { CreateInvoicePermission } from 'src/constants/permissionsList';
import useEnterInvoices from 'src/hooks/useEnterInvoices';
import AttachDocumentWizard from '../attach_document/AttachDocumentWizard';
import RequirePermissionWizard from './enter_invoice_wizard/RequirePermissionWizard';

interface IProps {
  openModal: boolean;
  closeModal: () => void;
}
const permissionMessage = (
  <p>
    Your account is not configured to create documents for this order. For inquiries, please contact
    customer support.
  </p>
);

const CreateInvoiceWithAttachment: React.FC<IProps> = ({ openModal, closeModal }) => {
  const { selectedInvoicePoRow, selectedInvoiceRow } = useEnterInvoices();

  return (
    <PermissionGuard
      permissions={CreateInvoicePermission}
      clientId={String(selectedInvoicePoRow?.buyerId)}
      or={true}
      fallback={
        <RequirePermissionWizard
          title={'Cannot Create Document'}
          content={permissionMessage}
          openModal={openModal}
          closeModal={closeModal}
        />
      }
    >
      <AttachDocumentWizard
        openModal={openModal}
        closeModal={closeModal}
        title={
          selectedInvoiceRow?.receiptId
            ? 'Attach to Existing Invoice/Credit Memo'
            : 'Create New Invoice/Credit Memo'
        }
        noOfAttachments={selectedInvoiceRow?.numOfAttachments}
        hasPoMpa={
          !selectedInvoiceRow?.receiptId && !!((selectedInvoicePoRow?.allocations?.length || 0) > 1)
        }
      />
    </PermissionGuard>
  );
};

export default CreateInvoiceWithAttachment;
